<template lang="html">
<CollapseItem
  :title="$depot.otherGate(gate.id, depot_id).name"
  :name="index">
    <div class="flex-container panel-head align-top">
      <div class="flex-item">
        <p>{{$t('INDENT_REFERENCE_ID')}} : <strong>{{$depot.otherGate(gate.id, depot_id).reference_id}} </strong></p>
        <p>{{$t('INDENT_LOADERS')}} :
          <strong>
            {{this.loaders[gate.loader_available] &&
              this.loaders[gate.loader_available].name || this.loaders[0].name}}
          </strong>
        </p>
      </div>
      <div class="flex-item text-right">
        <p>{{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}} :
          <strong>
            {{gate.loading_date | moment("DD MMM YYYY")}}
          </strong>
        </p>
        <p>{{$t('INDENT_PAID_BY')}} :
          <strong>
            {{this.paidBy[gate.paid_by] && this.paidBy[gate.paid_by].name || this.paidBy[0].name}}
          </strong>
        </p>
      </div>
    </div>
    <Table
      :data="tableData"
      :stripe="true"
      class="table-striped bordered mt-15"
      max-height="250px">
      <TableColumn
        :prop="ref_id"
        label="REF ID"
        width="75">
      </TableColumn>
      <TableColumn
        :prop="shipped_to"
        label="Shipped To"
        width="120">
      </TableColumn>
      <TableColumn
        :prop="sold_to"
        label="REF ID"
        width="75">
      </TableColumn>
      <TableColumn
        :prop="sold_to"
        label="Sold To"
        width="120">
      </TableColumn>
      <TableColumn
        :prop="unloaders"
        label="Unloaders"
        width="85">
      </TableColumn>
      <TableColumn
        :prop="paid_by"
        label="Paid By"
        width="65">
      </TableColumn>
      <TableColumn
        :prop="expected_date"
        label="Expected Date">
      </TableColumn>
    </Table>
  </CollapseItem>
</template>

<script>
import { loaders, paidBy } from '@/constants/order';

export default {
  props: ['gate', 'consignees', 'depot_id', 'isReturnVendor', 'index'],
  data() {
    return {
      loaders,
      paidBy,
    };
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.gate-wrapper {
  //box-shadow: 0 2px 7px 0 rgba(215, 215, 215, 0.5);
  //margin-bottom: 20px;
  .gate {
    .bg-gate {
      background-color: #f9fafa;
      padding: 20px 0;
      margin: 0 0 10px 0;
    }
    .gate-title {
      @extend %semi-bold;
      color: $primary-text;
      line-height: 40px;
      font-size: 1.6rem;
      margin: 0px 10px 0px 0;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}

.consignee-detail {
  .consignee-title {
    @extend %bold;
    color: $primary-text;
    font-size: 1.6rem;
  }
  .consignee-header {
    padding: 10px 0px;
    margin: 0 0 10px 0;
  }
  .consignee-detail-table {
    padding: 0px 10px;
    table {
      width: 100%;
      th {
        text-align: left;
        color: $sec-text;
        font-size: 1.2rem;
        margin-bottom: 10px;
        font-weight: normal;
        text-transform: uppercase;
      }
    }
    .consignee-tr {
      line-height: 32px;
      .consignee-td {
        color: $sec-text;
        font-family: $fontSemibold;
        font-size: 1.2rem;
        .edit-consignee {
          border-bottom: 1px solid #dee5e6;
          padding: 0px 15px 2px 0px;
        }
      }
    }
  }
}
</style>
